<mat-toolbar
  [class.mat-elevation-z2]="elevated"
  [class.bottom-border]="border"
  [appAnimateWithScroll]="animateShadow ? shadowAnimation : null"
  [animationEnd]="56">
  <ng-content select="[header-navigation]"></ng-content>
  <div class="header-title-container"
    [appAnimateWithScroll]="animateTitle ? titleAnimation : null"
    [animationEnd]="100">
    <ng-content select="[header-title]"></ng-content>
  </div>
  <ng-content select="[header-actions]"></ng-content>
</mat-toolbar>
